import React from "react";
var __jsx = React.createElement;
import stl from "./SingleTrendCard.module.css";
import useHelpers from "@hooks/useHelpers";
var SingleTrendCard = function SingleTrendCard(_ref) {
  var _trend$makes, _trend$models;
  var trend = _ref.trend,
    isEager = _ref.isEager;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    className: stl.STC_Container,
    href: createUrl("/trend/".concat(trend === null || trend === void 0 ? void 0 : trend.perma_link))
  }, /*#__PURE__*/React.createElement("img", {
    loading: isEager ? "eager" : "lazy",
    src: trend === null || trend === void 0 ? void 0 : trend.list_img,
    alt: trend === null || trend === void 0 ? void 0 : trend.h1_tag,
    width: 370,
    height: 278
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.contentContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.tagsContainer
  }, (trend === null || trend === void 0 ? void 0 : trend.makes) && (trend === null || trend === void 0 ? void 0 : (_trend$makes = trend.makes) === null || _trend$makes === void 0 ? void 0 : _trend$makes.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: stl.tag
    }, item);
  })), trend === null || trend === void 0 ? void 0 : (_trend$models = trend.models) === null || _trend$models === void 0 ? void 0 : _trend$models.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: stl.tag
    }, item);
  })), /*#__PURE__*/React.createElement("h2", null, trend === null || trend === void 0 ? void 0 : trend.h1_tag))));
};
export default SingleTrendCard;